import type { MenuSection } from '@1js/acui-menu/lib/components/MenuDefinition';
import type { MenuItemControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/controls/Menu';
import { createMailGeneratedMenuItem } from '../../util/createMailRibbonButton';
import {
    options_density_modeCompact,
    options_density_modeRoomy,
    options_density_modeCozy,
} from 'owa-display-density-option/lib/strings.locstring.json';
import loc from 'owa-localize';
import { getUserConfiguration } from 'owa-session-store';
import { onDensityClicked } from '../../util/commandActions';
import type DisplayDensityMode from 'owa-service/lib/contract/DisplayDensityMode';

export default function getDensitySections(): MenuSection[] {
    let sections: MenuItemControlProps[] = [];

    const densities: { mode: DisplayDensityMode; label: string }[] = [
        { mode: 'Full', label: loc(options_density_modeRoomy) },
        { mode: 'Simple', label: loc(options_density_modeCozy) },
        { mode: 'Compact', label: loc(options_density_modeCompact) },
    ];
    const densityModeSelected = getUserConfiguration().UserOptions?.DisplayDensityMode;

    densities.forEach(density => {
        sections.push(
            createMailGeneratedMenuItem(
                density.mode,
                density.label,
                undefined /*tooltip*/,
                () => {
                    onDensityClicked(density.mode);
                },
                undefined /* keytipProps */,
                density.mode === densityModeSelected
            )
        );
    });

    return [
        {
            controls: sections,
        },
    ];
}
